import React, { useCallback } from 'react';
import classNames from 'classnames';
import Image from 'react-bootstrap/Image';
import { Triangle, TriangleFill } from 'react-bootstrap-icons';

import CellContent from './CellContent';
import CompanyIcon from './Decorator/CompanyIcon';

import InterestUri from '../../../Enum/InterestUri';
import { CellDecorator } from '../../../Enum/TableDecorator';
import { HeaderCell } from '../../../Interface/Hook/Interest/InterestTableDTO';
import { Sort } from '../../../Interface/Table/Sort';

import { sortingChanged } from '../../../Store/Filter/action';
import { useDispatch } from 'react-redux';

interface Props {
    data: HeaderCell[];
    section?: InterestUri;
    sort?: Sort;
}

const Header: React.FC<Props> = ({ data, section, sort }: Props) => {
    const dispatch = useDispatch();

    const changeSort = useCallback(
        (cell: HeaderCell) => {
            if (sort && section && cell.sortable) {
                dispatch(
                    sortingChanged(section, {
                        prop: cell.prop,
                        ascending: sort.prop !== cell.prop ? sort.ascending : !sort.ascending,
                    }),
                );
            }
        },
        [dispatch, sort, section],
    );

    return (
        <thead>
            <tr>
                {data.map((cell, index) => (
                    <th
                        className={classNames(cell.className ?? '', { sortable: cell.sortable })}
                        key={index}
                        onClick={() => changeSort(cell)}
                    >
                        <div className="content d-flex">
                            {!cell.decorator && cell.value}
                            {cell.decorator === CellDecorator.Image && <Image src={cell.value} height={22} />}
                            {cell.decorator === CellDecorator.CompanyIcon && (
                                <CompanyIcon finDataCode={cell.value as string} />
                            )}
                            {cell.appendix !== undefined && typeof cell.appendix === 'string' && (
                                cell.appendix
                            )}
                            {cell.appendix !== undefined && typeof cell.appendix === 'object' && (
                                <CellContent {...cell.appendix} />
                            )}
                            {sort && cell.sortable && (
                                <span className={classNames('pull-right', { ascending: sort.ascending })}>
                                    {cell.prop !== sort.prop && sort.ascending && <Triangle />}
                                    {cell.prop !== sort.prop && !sort.ascending && <Triangle />}
                                    {cell.prop === sort.prop && sort.ascending && <TriangleFill />}
                                    {cell.prop === sort.prop && !sort.ascending && <TriangleFill />}
                                </span>
                            )}
                        </div>
                    </th>
                ))}
            </tr>
        </thead>
    );
};

export default Header;
